// Generated by the AI website content export.
export const aiContentPages = [
  {
    "value": "ai-agent",
    "title": "ai-agent"
  },
  {
    "value": "buggies-commercial-vehicles",
    "title": "buggies-commercial-vehicles"
  },
  {
    "value": "building-engineering",
    "title": "building-engineering"
  },
  {
    "value": "dealers-distributors",
    "title": "dealers-distributors"
  },
  {
    "value": "hardware-trade-supplies",
    "title": "hardware-trade-supplies"
  },
  {
    "value": "help/ai",
    "title": "help/ai"
  },
  {
    "value": "industrial-mro",
    "title": "industrial-mro"
  },
  {
    "value": "manufacturers-brands",
    "title": "manufacturers-brands"
  },
  {
    "value": "parts-aftermarket",
    "title": "parts-aftermarket"
  },
  {
    "value": "rental-businesses",
    "title": "rental-businesses"
  },
  {
    "value": "resources/add-faq-knowledge",
    "title": "resources/add-faq-knowledge"
  },
  {
    "value": "resources/add-sop-and-policy-knowledge",
    "title": "resources/add-sop-and-policy-knowledge"
  },
  {
    "value": "resources/ai-agent-as-first-digital-sales-touchpoint",
    "title": "resources/ai-agent-as-first-digital-sales-touchpoint"
  },
  {
    "value": "resources/ai-agent-benefits-for-industrial-b2b",
    "title": "resources/ai-agent-benefits-for-industrial-b2b"
  },
  {
    "value": "resources/ai-agent-console-agent-setup",
    "title": "resources/ai-agent-console-agent-setup"
  },
  {
    "value": "resources/ai-agent-console-knowledge-base",
    "title": "resources/ai-agent-console-knowledge-base"
  },
  {
    "value": "resources/ai-agent-console-payment-methods",
    "title": "resources/ai-agent-console-payment-methods"
  },
  {
    "value": "resources/ai-agent-console-playground",
    "title": "resources/ai-agent-console-playground"
  },
  {
    "value": "resources/ai-agent-industrial-enquiry-workflows",
    "title": "resources/ai-agent-industrial-enquiry-workflows"
  },
  {
    "value": "resources/ai-agent-pre-launch-checklist",
    "title": "resources/ai-agent-pre-launch-checklist"
  },
  {
    "value": "resources/ai-agent-vs-chatgpt",
    "title": "resources/ai-agent-vs-chatgpt"
  },
  {
    "value": "resources/ai-agent-vs-generic-ai-agents",
    "title": "resources/ai-agent-vs-generic-ai-agents"
  },
  {
    "value": "resources/ai-agents-vs-chatbots-for-industrial-b2b",
    "title": "resources/ai-agents-vs-chatbots-for-industrial-b2b"
  },
  {
    "value": "resources/ai-webstore-vs-company-website",
    "title": "resources/ai-webstore-vs-company-website"
  },
  {
    "value": "resources/choose-plan-and-sign-up",
    "title": "resources/choose-plan-and-sign-up"
  },
  {
    "value": "resources/company-information-to-prepare-for-ai-agents",
    "title": "resources/company-information-to-prepare-for-ai-agents"
  },
  {
    "value": "resources/enquiries-an-ai-agent-can-handle",
    "title": "resources/enquiries-an-ai-agent-can-handle"
  },
  {
    "value": "resources/how-ai-agents-help-webstore-visitors-understand-products",
    "title": "resources/how-ai-agents-help-webstore-visitors-understand-products"
  },
  {
    "value": "resources/how-ai-agents-learn-from-business-knowledge",
    "title": "resources/how-ai-agents-learn-from-business-knowledge"
  },
  {
    "value": "resources/how-ai-webstore-creates-a-digital-sales-channel",
    "title": "resources/how-ai-webstore-creates-a-digital-sales-channel"
  },
  {
    "value": "resources/how-ai-webstore-helps-capture-sales-enquiries",
    "title": "resources/how-ai-webstore-helps-capture-sales-enquiries"
  },
  {
    "value": "resources/how-ai-webstore-qualifies-marketing-enquiries",
    "title": "resources/how-ai-webstore-qualifies-marketing-enquiries"
  },
  {
    "value": "resources/how-antbuildz-connects-webstore-and-ai-agent",
    "title": "resources/how-antbuildz-connects-webstore-and-ai-agent"
  },
  {
    "value": "resources/how-to-improve-ai-agent-accuracy",
    "title": "resources/how-to-improve-ai-agent-accuracy"
  },
  {
    "value": "resources/how-to-structure-b2b-product-knowledge",
    "title": "resources/how-to-structure-b2b-product-knowledge"
  },
  {
    "value": "resources/how-to-test-ai-agent-responses",
    "title": "resources/how-to-test-ai-agent-responses"
  },
  {
    "value": "resources/onboarding-troubleshooting",
    "title": "resources/onboarding-troubleshooting"
  },
  {
    "value": "resources/prepare-and-check-product-import",
    "title": "resources/prepare-and-check-product-import"
  },
  {
    "value": "resources/prepare-company-workspace",
    "title": "resources/prepare-company-workspace"
  },
  {
    "value": "resources/prepare-inventory-connection",
    "title": "resources/prepare-inventory-connection"
  },
  {
    "value": "resources/quick-start-ai-agent",
    "title": "resources/quick-start-ai-agent"
  },
  {
    "value": "resources/understand-usage-and-billing",
    "title": "resources/understand-usage-and-billing"
  },
  {
    "value": "resources/webstore-onboarding-checklist",
    "title": "resources/webstore-onboarding-checklist"
  },
  {
    "value": "resources/what-an-ai-agent-can-and-cannot-do",
    "title": "resources/what-an-ai-agent-can-and-cannot-do"
  },
  {
    "value": "resources/what-is-an-ai-sales-agent",
    "title": "resources/what-is-an-ai-sales-agent"
  },
  {
    "value": "resources/when-ai-agents-should-hand-over-to-humans",
    "title": "resources/when-ai-agents-should-hand-over-to-humans"
  },
  {
    "value": "resources/why-a-product-catalogue-is-not-enough",
    "title": "resources/why-a-product-catalogue-is-not-enough"
  },
  {
    "value": "resources/why-ai-agents-work-with-an-integrated-webstore",
    "title": "resources/why-ai-agents-work-with-an-integrated-webstore"
  },
  {
    "value": "resources/why-ai-sales-agents-need-business-knowledge",
    "title": "resources/why-ai-sales-agents-need-business-knowledge"
  },
  {
    "value": "resources/why-faqs-agreements-and-policies-matter-for-ai-agents",
    "title": "resources/why-faqs-agreements-and-policies-matter-for-ai-agents"
  },
  {
    "value": "resources/why-industry-specific-ai-agents-matter",
    "title": "resources/why-industry-specific-ai-agents-matter"
  },
  {
    "value": "resources/why-product-data-quality-matters-for-ai-agents",
    "title": "resources/why-product-data-quality-matters-for-ai-agents"
  }
];
